const VERSION: string = '0.1.7-prod.106'
export default VERSION;
